import React, { useState } from "react";
import productImage from "../assets/19.jpeg";
import { saveContactMessage } from "../services/contact";
import PageHero from "../components/PageHero";

const initialFormState = {
  name: "",
  email: "",
  message: "",
};

const Contact = () => {
  const [formData, setFormData] = useState(initialFormState);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const normalizedData = {
      name: formData.name.trim(),
      email: formData.email.trim(),
      message: formData.message.trim(),
    };

    if (!normalizedData.name || !normalizedData.email || !normalizedData.message) {
      setSuccessMessage("");
      setErrorMessage("Please fill in your name, email, and message.");
      return;
    }

    setIsSubmitting(true);
    setErrorMessage("");
    setSuccessMessage("");

    try {
      await saveContactMessage(normalizedData);
      setFormData(initialFormState);
      setSuccessMessage("Message sent successfully.");
    } catch (error) {
      setErrorMessage(error.message || "Unable to send your message right now.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full">
      <PageHero
        eyebrow="Get in touch"
        title="We’d love to hear from you."
        description="Send us a message for product questions, order help, delivery updates, or general support. We usually respond as quickly as possible."
        image={productImage}
        imageAlt="Zea Mays contact"
        primaryAction={{ href: "mailto:zeamaysfood@gmail.com", label: "Email Us" }}
        secondaryAction={{ to: "/products", label: "Browse Products" }}
        stats={[
          { label: "Support", value: "Fast replies" },
          { label: "Orders", value: "Checkout help" },
          { label: "Delivery", value: "Status updates" },
          { label: "Location", value: "Ikorodu" },
        ]}
        compact
      />

      <div className="w-full min-h-screen bg-green-100 px-6 py-20">
        <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-2">
          <div className="rounded-2xl bg-white p-8 shadow-lg">
            <h1 className="mb-6 text-center text-4xl font-bold text-red-700 lg:text-left">
              Contact Us
            </h1>

            <form onSubmit={handleSubmit} className="space-y-6">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
                required
                className="w-full rounded-xl border px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-red-700"
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Your Email"
                required
                className="w-full rounded-xl border px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-red-700"
              />
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message"
                required
                rows="5"
                className="w-full rounded-xl border px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-red-700"
              ></textarea>

              {errorMessage ? (
                <p className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                  {errorMessage}
                </p>
              ) : null}

              {successMessage ? (
                <p className="rounded-xl border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-700">
                  {successMessage}
                </p>
              ) : null}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full rounded-xl bg-red-700 py-3 font-semibold text-white transition hover:bg-green-300 disabled:cursor-not-allowed disabled:opacity-70"
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>

          <div className="flex justify-center lg:justify-end">
            <div className="w-full max-w-xl overflow-hidden rounded-3xl bg-white p-3 shadow-lg">
              <img
                src={productImage}
                alt="Zea Mays product"
                className="h-full max-h-[520px] w-full rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
